import { RepaymentPlanCancellationReason as GqlRepaymentPlanCancellationReason } from '@willow/graphql-iso/src/app';
import { assertNever, RepaymentPlanCancellationReason } from '@willow/types-iso';

export const getRepaymentPlanCancellationReasonLabel = (
  reason: RepaymentPlanCancellationReason | GqlRepaymentPlanCancellationReason,
): string => {
  switch (reason) {
    case 'insufficientPayments':
    case GqlRepaymentPlanCancellationReason.InsufficientPayments:
      return 'Payments not made in full/ on time';
    case 'referringToForeclosure':
    case GqlRepaymentPlanCancellationReason.ReferringToForeclosure:
      return 'Referring to foreclosure';
    case 'loanReinstated':
    case GqlRepaymentPlanCancellationReason.LoanReinstated:
      return 'Loan has been reinstated';
    case 'evaluatingForFlexMod':
    case GqlRepaymentPlanCancellationReason.EvaluatingForFlexMod:
      return 'Evaluating for Flex Modification';
    case 'evaluatingForDeferment':
    case GqlRepaymentPlanCancellationReason.EvaluatingForDeferment:
      return 'Evaluating for Payment Deferral';
    case 'evaluatingForDisasterFlexMod':
    case GqlRepaymentPlanCancellationReason.EvaluatingForDisasterFlexMod:
      return 'Evaluating for Disaster Flex Modification';
    case 'evaluatingForDisasterDeferment':
    case GqlRepaymentPlanCancellationReason.EvaluatingForDisasterDeferment:
      return 'Evaluating for Disaster Payment Deferral';
    case 'noLongerEligible':
    case GqlRepaymentPlanCancellationReason.NoLongerEligible:
      return 'No longer eligible for workout plan';
    case 'other':
    case GqlRepaymentPlanCancellationReason.Other:
      return 'Other';
    default:
      assertNever(reason);
  }
};
